import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'sitesSlice';
export const actionTypes = {
  FETCH_ALL_USER_SITES: `${FEATURE_NAME}/FETCH_ALL_USER_SITES`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
